import { type RefObject, useEffect } from 'react';

export const useScrollIntoView = (
  ref: RefObject<HTMLDivElement | null>,
  isActive: boolean,
) => {
  useEffect(() => {
    if (isActive && ref.current) {
      const scrollY = window.scrollY;
      ref.current.scrollIntoView?.({ block: 'center' });
      window.scrollTo(0, scrollY);
    }
  }, [isActive, ref]);
};
